import clamp from 'lodash/clamp';
import defaultTo from 'lodash/defaultTo';
import templates from '../components/configurator/templates';

const clampChoiceValue = (value) => (choice) => clamp(
  value,
  defaultTo(choice.minValue, -Infinity),
  defaultTo(choice.maxValue, Infinity),
);

export default (config) => {
  const configuratorSettings = {
    templates,
    productLine: 'countertops',
    productLineId: '8',
    customValidators: {},
    executeRulesApi: `${config.eleanorBaseUrl}/catalog/productconfiguration/ExecuteRulesViaPost`,
    loadDictionaryDefinitionApi: `${config.eleanorBaseUrl}/DictionaryManagement/Definition/DictionaryDefinitionForTerm`,
    loadDictionaryTermsApi: `${config.eleanorBaseUrl}/DictionaryManagement/Definition/AllDictionaryEntries`,
    visualizationApi: `${config.eleanorBaseUrl}/api/visualization/url`,
    siteId: config?.siteId,
    productId: config?.partnerProductId,
    productName: config?.title,
    brand: config?.brand,
    userId: null,
    hiddenOptions: [982],
    mixPanelConfig: {
      timedEvent: 'PCP_TimeDevotion',
      isMixPanelActive: true,
      mixPanelCode: 'c2360a502ff32f3443acba1f20009e04',
    },
    preconfiguration: {},
    persistenceKey: config.productId,
    eleanorBaseUrl: config.eleanorBaseUrl,
    zipcode: {},
    onSaveSuccess: {},
    getDefaultChoiceValue: [
      {
        predicate: (choice, option) => option.internalName === 'Sq_Ft',
        getValue: clampChoiceValue(0),
      },
    ],
  };

  return configuratorSettings;
};
